import { apiClient } from '@/config/api';

export type AdminCommonAreaAttribute = {
  id: number;
  name: string;
  uuid: string | null;
  currentValue: string | null;
  currentValueTs: string | null;
  type: {
    id: number;
    code: string | null;
    name: string | null;
    unit: string | null;
  } | null;
  device: {
    id: number;
    name: string | null;
    code: string | null;
  } | null;
  box: {
    id: number;
    name: string | null;
    code: string | null;
  } | null;
  building: {
    id: number;
    name: string | null;
    code: string | null;
  } | null;
};

export const adminCommonAreasAttributesService = {
  async getAttributes(projectId: number): Promise<AdminCommonAreaAttribute[]> {
    const { data } = await apiClient.get<AdminCommonAreaAttribute[]>(
      `/admin/projects/${projectId}/common-areas/attributes`
    );
    return data;
  },

  async addAttribute(projectId: number, attributeId: number): Promise<{ id: number; attribute: { id: number; name: string } }> {
    const { data } = await apiClient.post<{ id: number; attribute: { id: number; name: string } }>(
      `/admin/projects/${projectId}/common-areas/attributes`,
      { attributeId }
    );
    return data;
  },

  async removeAttribute(projectId: number, attributeId: number): Promise<void> {
    await apiClient.delete(`/admin/projects/${projectId}/common-areas/attributes/${attributeId}`);
  },
};
